import React, { useEffect, useState } from 'react';

/**
 * Unit condition clip picker — gallery / files app se (~30 sec, server ≤5MB).
 */
export default function OptionalVideoUpload({
  title = 'Condition video',
  hint = 'Max ~30 sec — server par compress hoke ≤5 MB save hogi.',
  file,
  onChange,
  className = 'mb-2'
}) {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  return (
    <div className={className}>
      {title ? (
        <label className="form-label">
          {title} <span className="text-muted fw-normal">(optional)</span>
        </label>
      ) : null}
      <input
        type="file"
        className="form-control form-control-sm"
        accept="video/mp4,video/webm,video/quicktime,video/*"
        onChange={(e) => onChange(e.target.files[0] || null)}
      />
      {hint ? <small className="text-muted d-block mt-1">{hint}</small> : null}
      <small className="text-muted d-block mt-1">Gallery se bhi choose kar sakte ho.</small>
      {preview ? (
        <div className="mt-2">
          <video
            src={preview}
            controls
            playsInline
            style={{ width: '100%', maxHeight: 160, borderRadius: 8, border: '1px solid #dee2e6' }}
          />
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary mt-1 w-100"
            onClick={() => onChange(null)}
          >
            Remove video
          </button>
        </div>
      ) : null}
    </div>
  );
}
